import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { CalendarCheck } from "lucide-react";

export default function FloatingCTA() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 60 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 1.5, duration: 0.6 }}
      className="fixed bottom-4 left-1/2 -translate-x-1/2 z-40 md:hidden"
    >
      <Link
        to="/kontakt"
        data-testid="floating-cta"
        className="inline-flex items-center gap-2 rounded-full bg-gold px-6 py-3.5 text-sm font-semibold text-ink shadow-[0_8px_30px_rgba(201,169,97,0.5)]"
      >
        <CalendarCheck size={18} />
        Kostenlose Besichtigung
      </Link>
    </motion.div>
  );
}
